import { useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchEmployerPageContent } from "../../../redux/actions/company_action";
import {
  ButtonStyled,
  FlexContainerStyled,
  ImageContainer,
  LinkGridContainer,
  LinkStyled,
  ParentContainer,
  TextGridContainer,
  TitleContainer,
  TitleStyled,
  WorkCultureReportImage,
} from "./styles";

let query = `
    reportDownload {
      title
      description
      image {
        data {
          attributes {
            url
          }
        }
      }
     ctaButton
     ctaButtonLink
     secondaryCtaButton   
     secondaryCtaButtonLink 
    }
  `;

export default function EmployerLandingWorkCultureReport() {
  const [solutions, setSolutions] = useState(null);

  const dispatch = useDispatch();
  const router = useRouter();
  const isMobileView = useMediaQuery("(max-width: 779.95px)");

  const handleRedirectDownload = () => {
    if (solutions?.ctaButtonLink) {
      router.replace(solutions.ctaButtonLink);
    }
  };

  async function fetchData() {
    const response = await dispatch(fetchEmployerPageContent(query));

    const reportDownload = response?.reportDownload || null;

    setSolutions(reportDownload);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ParentContainer>
      <FlexContainerStyled>
        <ImageContainer>
          <WorkCultureReportImage
            src={solutions?.image?.data?.attributes?.url}
            alt="work-culture-report-image"
          />
          {/* {isMobileView && <FlameIcon />} */}
        </ImageContainer>
        <TextGridContainer>
          <TitleContainer>
            <TitleStyled variant="title">
              {solutions?.title ||
                "Change How You See the 3 Generations at Work"}
            </TitleStyled>
            {/* {!isMobileView && <FlameIcon />} */}
          </TitleContainer>
          <TitleStyled variant="description">
            {solutions?.description ||
              "Hiredly’s Work Culture Report 2025 reveals surprising data about Gen XYZ, and what it really takes to win talent across generations."}
          </TitleStyled>
          <LinkGridContainer>
            <ButtonStyled onClick={handleRedirectDownload}>
              {solutions?.ctaButton || "download now"}
            </ButtonStyled>
            {solutions?.secondaryCtaButton?.trim() && (
              <LinkStyled
                href={
                  solutions?.secondaryCtaButtonLink ||
                  "https://hub.hiredly.com/workculture"
                }
              >
                {solutions.secondaryCtaButton}
              </LinkStyled>
            )}
          </LinkGridContainer>
        </TextGridContainer>
      </FlexContainerStyled>
    </ParentContainer>
  );
}
